import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Text, Grid, Image, Link, HStack } from '@chakra-ui/react';
import NewsletterSignup from '../components/NewsletterSignup';
import { blogPosts } from '../data/blogPosts';

const Blog = () => {
  const { t } = useTranslation('blog');
  const navigate = useNavigate();
  const { lng } = useParams<{ lng: string }>();
  const currentLanguage = lng || 'en';

  const getLocalizedPath = (path: string) => {
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    return `/${currentLanguage}${cleanPath}`;
  };
  return (
    <Box maxW="1200px" mx="auto" p={8} bg="white" minH="100vh">
      {/* Hero Section */}
      <Box 
        textAlign="center" 
        mb={16} 
        py={12}
        border="4px solid black"
        mx={4}
      >
        <Text 
          fontSize={{ base: "4xl", md: "6xl" }} 
          fontWeight="bold" 
          mb={6} 
          color="black"
          fontFamily="Abel"
        >
          {t('hero.title')}
        </Text>
        
        <Box w="60px" h="2px" bg="black" mx="auto" mb={6} />
        
        <Text 
          fontSize={{ base: "lg", md: "xl" }} 
          textAlign="center" 
          color="black" 
          lineHeight="1.8"
          fontFamily="Source Code Pro"
        >
          {t('hero.subtitle')}
        </Text>
      </Box>

      {/* Blog Posts Grid */}
      <Grid 
        templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }} 
        gap={8} 
        px={4}
      >
        {blogPosts.map((post) => (
          <Link 
            key={post.id} 
            onClick={() => navigate(getLocalizedPath(`/blog/${post.slug}`))}
            cursor="pointer" 
            _hover={{ textDecoration: 'none' }}
          >
            <Box 
              border="4px solid black"
              bg="white"
              transition="all 0.3s ease"
              _hover={{ transform: "translateY(-2px)" }}
              h="100%"
            >
              <Box h="250px">
                <Image
                  src={post.image}
                  alt={post.title}
                  w="100%"
                  h="100%"
                  objectFit="cover"
                  loading="lazy"
                />
              </Box>
              
              <Box p={6}>
                <HStack spacing={4} mb={3}>
                  <Text fontSize="sm" color="black" fontFamily="Source Code Pro">
                    {post.date}
                  </Text>
                  <Text fontSize="sm" color="black" fontFamily="Source Code Pro">
                    {t('metadata.readTime', { time: post.readTime.replace(' min read', '') })}
                  </Text>
                </HStack>
                
                <Text 
                  fontSize="xl" 
                  fontWeight="bold" 
                  mb={3}
                  color="black"
                  fontFamily="Abel"
                  lineHeight="1.3"
                >
                  {t(`posts.${post.id}.title`)}
                </Text>
                
                <Text 
                  fontSize="md" 
                  color="black" 
                  lineHeight="1.6"
                  fontFamily="Source Code Pro"
                >
                  {t(`posts.${post.id}.excerpt`)}
                </Text>
              </Box>
            </Box>
          </Link>
        ))}
      </Grid>

      {/* Newsletter Signup */}
      <Box mt={16} maxW="400px" mx="auto">
        <NewsletterSignup 
          source="blog"
          title={t('newsletter.title')}
          description={t('newsletter.description')}
          variant="inline"
        />
      </Box>

    </Box>
  );
};

export default Blog;